import type { ChangeEvent, FC, RefObject } from "react";

export const UploadImageInput: FC<{
  inputFileRef: RefObject<HTMLInputElement | null>;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}> = ({ inputFileRef, onChange }) => (
  <input
    ref={inputFileRef}
    type="file"
    accept="image/apng, image/avif, image/gif, image/ico, image/jpg, image/jpeg, image/png, image/svg, image/webp"
    id="local-image"
    style={{ display: "none" }}
    onChange={onChange}
  />
);
